export function symcodAccordeon(){
	
	jQuery(".accordeon-item").on("click",".accordeon-title", function(e){
			e.preventDefault();
			let parent = jQuery(this).parent();
			let aBody = parent.children(".accordeon-body");
			
			
			
			if( parent.hasClass("active")){
				parent.removeClass("active");
				aBody.slideUp(300);
				return;
			}
			
			jQuery(".accordeon-item").removeClass("active");
			jQuery(".accordeon-body").slideUp();
			
			parent.addClass("active");
			aBody.slideDown( 300 );
			
			jQuery(".galerie-simple").slick('setPosition');
			
	});	

}